import isString from 'lodash/isString'

export const currencyMap = {
  rub: '₽',
  usd: '$',
  eur: '€',
}

const currencyInPrefix = ['usd', 'eur']

function getCurrency(currency) {
  if (!currency) {
    return ''
  }

  const alias = currency.toLowerCase()
  return alias in currencyMap ? currencyMap[alias] : currency
}

const format = (amount, currency = '', i18nOrOptions = false) => {
  const isOptionsObject = typeof i18nOrOptions === 'object' && i18nOrOptions !== null
  const i18n = isOptionsObject ? i18nOrOptions.i18n || false : i18nOrOptions
  const fractionDigits = isOptionsObject ? (i18nOrOptions.fractionDigits ?? 2) : 2

  const locale = i18n || global.locale

  const symbol = getCurrency(currency)

  const prefix = isString(currency) ? currencyInPrefix.indexOf(currency.toLowerCase()) > -1 : ''

  const values = parseFloat(amount).toFixed(fractionDigits).split('.')
  const decimal = parseInt(values[0]).toLocaleString(locale)

  if (fractionDigits === 0) {
    if (prefix) {
      return symbol + ' ' + decimal
    }

    return decimal + '<span class="currency"> ' + symbol + '</span>'
  }

  const fraction = (locale === 'ru' ? ',' : '.') + values[1]

  if (prefix) {
    return symbol + ' ' + decimal + '<span class="currency">' + fraction + '</span>'
  } else {
    return decimal + '<span class="currency">' + fraction + ' ' + symbol + '</span>'
  }
}

export default format

export const formatByLocale = (value, i18n, options = {}) => {
  return (Number(value) || 0).toLocaleString(i18n || global.locale, {
    ...options,
  })
}

export const formatToString = (amount, currency, fractionDigits = 2) => {
  const locale = global.locale

  const symbol = getCurrency(currency)
  const prefix = currencyInPrefix.indexOf(currency.toLowerCase()) > -1

  const values = parseFloat(amount).toFixed(fractionDigits).split('.')
  const decimal = parseInt(values[0]).toLocaleString(global.locale)
  const fraction = (locale === 'ru' ? ',' : '.') + values[1]

  if (prefix) {
    return symbol + ' ' + decimal + fraction
  } else {
    return decimal + fraction + ' ' + symbol
  }
}
